/* eslint-disable */
import React from 'react';
import Tooltip from '../common/ToolTip';

export const EyeIcon = () => (
	<Tooltip text="View Details">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
		>
			<rect
				x="0.5"
				y="0.5"
				width="39"
				height="39"
				rx="4.5"
				fill="white"
			/>
			<rect
				x="0.5"
				y="0.5"
				width="39"
				height="39"
				rx="4.5"
				stroke="#D9D9D9"
			/>
			<path
				d="M10.062 20.3484C9.97868 20.1238 9.97868 19.8769 10.062 19.6524C10.8737 17.6842 12.2515 16.0014 14.0208 14.8173C15.79 13.6331 17.8711 13.001 20 13.001C22.129 13.001 24.21 13.6331 25.9792 14.8173C27.7485 16.0014 29.1263 17.6842 29.938 19.6524C30.0214 19.8769 30.0214 20.1238 29.938 20.3484C29.1263 22.3165 27.7485 23.9993 25.9792 25.1835C24.21 26.3676 22.129 26.9997 20 26.9997C17.8711 26.9997 15.79 26.3676 14.0208 25.1835C12.2515 23.9993 10.8737 22.3165 10.062 20.3484Z"
				stroke="#1E1E1E"
				strokeWidth="1.5"
			/>
			<path
				d="M20 23.0004C21.6569 23.0004 23 21.6572 23 20.0004C23 18.3435 21.6569 17.0004 20 17.0004C18.3432 17.0004 17 18.3435 17 20.0004C17 21.6572 18.3432 23.0004 20 23.0004Z"
				stroke="#1E1E1E"
				strokeWidth="1.5"
			/>
		</svg>
	</Tooltip>
);

// export const LearnersIcon = () => (
//   <Tooltip text="View Learners">
//     <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
//       <rect x="0.5" y="0.5" width="39" height="39" rx="4.5" fill="white" />
//       <rect x="0.5" y="0.5" width="39" height="39" rx="4.5" stroke="#D9D9D9" />
//       <path d="M24 29V27C24 25.9391 23.5786 24.9217 22.8284 24.1716C22.0783 23.4214 21.0609 23 20 23H14C12.9391 23 11.9217 23.4214 11.1716 24.1716C10.4214 24.9217 10 25.9391 10 27V29" stroke="#1E1E1E" strokeWidth="1.5"/>
//     </svg>
//   </Tooltip>
// );
export const LearnersIcon = () => (
	<Tooltip text="View Learners">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
		>
			<rect
				x="0.5"
				y="0.5"
				width="39"
				height="39"
				rx="4.5"
				fill="white"
			/>
			<rect
				x="0.5"
				y="0.5"
				width="39"
				height="39"
				rx="4.5"
				stroke="#D9D9D9"
			/>

			<path
				d="M24 29V27C24 25.9391 23.5786 24.9217 22.8284 24.1716C22.0783 23.4214 21.0609 23 20 23H14C12.9391 23 11.9217 23.4214 11.1716 24.1716C10.4214 24.9217 10 25.9391 10 27V29"
				stroke="#1E1E1E"
				strokeWidth="1.5"
			/>

			<path
				d="M24 11.128C24.8578 11.3504 25.6174 11.8513 26.1597 12.5521C26.702 13.2529 26.9962 14.1139 26.9962 15C26.9962 15.8861 26.702 16.7471 26.1597 17.4479C25.6174 18.1487 24.8578 18.6496 24 18.872"
				stroke="#1E1E1E"
				strokeWidth="1.5"
			/>

			<path
				d="M30 29V27C29.9993 26.1137 29.7044 25.2528 29.1614 24.5523C28.6184 23.8519 27.8581 23.3516 27 23.13"
				stroke="#1E1E1E"
				strokeWidth="1.5"
			/>

			<path
				d="M21 15C21 17.2091 19.2091 19 17 19C14.7909 19 13 17.2091 13 15C13 12.7909 14.7909 11 17 11C19.2091 11 21 12.7909 21 15Z"
				stroke="#1E1E1E"
				strokeWidth="1.5"
			/>
		</svg>
	</Tooltip>
);

export const UploadIcon = () => (
	<Tooltip text="Upload Resource">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
		>
			<rect
				x="0.5"
				y="0.5"
				width="39"
				height="39"
				rx="4.5"
				fill="white"
			/>
			<rect
				x="0.5"
				y="0.5"
				width="39"
				height="39"
				rx="4.5"
				stroke="#D9D9D9"
			/>
			<path
				d="M20 10V23.3333M20 10L25.5556 15.5556M20 10L14.4444 15.5556"
				stroke="#1E1E1E"
				strokeWidth="1.5"
			/>
		</svg>
	</Tooltip>
);
